module.exports = __webpack_public_path__ + "nstatic/img/simple_tx.a8b5c6eb.png";